module.exports = __webpack_public_path__ + "images/howtouse/flow02_5c944f0cecad93b278f6d41d1a4ce4d4.png";